export const USER_API_ROUTES = {
  GET_CLASSES: "/users/customers/classes",
  SAVE_CLASS: "/users/customers/subscription/select-class",
};
